import {LaundryModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: LaundryModel = {
  id: '',
  companiaId: '',
  clienteId: '',
  siteId: '',
  campamentoId: '',
  tipoRecepcion: '',
  tipoAdministracion: '',
  puntoId: '',
  email: '',
  responsable: '',
  flagEnvioComprobante: false,
  telefono: '',
  servicioId: '',
  colaboradorId: '',
  habitacionId: '',
  nroBoleta: '',
  moduloId: '',
  camaId: '',
  estado: '',
  huesped: '',
  huespedId: '',
  tipoHuesped: '',
  empresa: '',
  proveedorId: '',
  proveedor: '',
  modulo: '',
  cama: '',
  habitacion: '',
  estadoOrden: '',
  bolsaCorrelativo: '',
  rotuladoCorrelativo: '',
  ...aditionalValues,
}
